module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "section",
    attrs: {
      "id": "sect3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/toc#sect3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broccoli and Cheddar Quiche with Brown Rice Crust")])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    staticStyle: {
      "height": "70vh"
    },
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "RecipebYieldb"
  }, [_vm._v("Yield: Serves 6 | Prep Time: 20 minutes | Cook Time: 50 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extract_r"
  }, [_vm._v("This brown rice crust is a healthier departure from the typical buttery flaky pastry. The crust recipe could even be repurposed when making pumpkin pie or savory tarts for a fun new twist.")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_c('strong', [_vm._v("INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("2 cups cooked brown rice, cooled (see Notes)")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1¼ cups finely grated cheddar cheese")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("¼ cup finely grated Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("5 large eggs")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ teaspoon herbes de Provence")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 pinch nutmeg")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("Salt and pepper, to taste")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("2 cups broccoli florets, blanched")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("6 ounces cremini mushrooms, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("4 scallions, sliced")]), _vm._v(" "), _c('p', {
    staticClass: "directions"
  }, [_c('strong', [_vm._v("DIRECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("1. Preheat the oven to 450°F.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("2. Combine the rice, ¼ cup of the cheddar cheese, the Parmesan cheese, and 1 egg.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("3. Press the mixture into the bottom and up the sides of a 9-inch pie pan to ¼-inch thickness.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("4. Bake for 7 minutes until the crust begins to brown.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("5. In a large bowl, beat the remaining 4 eggs with the herbes de Provence, nutmeg, salt, and pepper.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("6. After the crust has baked, lower the oven temperature to 375°F.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("7. Layer the broccoli, mushrooms, remaining 1 cup cheddar cheese, and scallions onto the crust.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("8. Pour the egg mixture over the vegetables and cheese. Bake for 35 to 40 minutes until set and the top is golden.")]), _vm._v(" "), _c('p', {
    staticClass: "notehead"
  }, [_c('strong', [_vm._v("NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "NotebText"
  }, [_vm._v("You’ll need about ⅔ cup uncooked brown rice to yield 2 cups cooked.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0922026e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/sect3.vue
// module id = 93
// module chunks = 0